<button 
    *ngIf="value > 0"
    class="notification flex items-center justify-center rounded-full text-white border border-solid border-white"
    type="button"
    (click)="openMessage($event)">
    {{ value }}
</button>